/****************************************************************************************************/
/* Module Imports */
/****************************************************************************************************/

require("./mobile-menu.js");
require('jquery-lazy');
require('jquery-backstretch');
//require('jquery-hoverintent');
require("waypoints/lib/jquery.waypoints.js");
require("waypoints/lib/shortcuts/sticky.js");
require("jquery-ui/ui/unique-id.js");
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/scroll-parent.js");
//require("page-scroll-to-id/jquery.malihu.PageScroll2id.js");

var popup = require("jquery-popup-overlay");
import Splide from '@splidejs/splide';
require('@splidejs/splide/dist/css/splide.min.css');
require('@splidejs/splide/dist/css/themes/splide-default.min.css');

//import { EventInterface } from '@splidejs/splide';
//import { FadeHero } from './splide-transition-fade-hero.ts'

window.Splide = Splide; // make splide available to widget scripts

/****************************************************************************************************/
/* Global Vars */
/****************************************************************************************************/

window.ww; // window width
window.wh; // window width
window.hh;
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.scrollDirection = "down"; // default
window.st = window.pageYOffset || document.documentElement.scrollTop;
var $header = $("#header");
function refreshScrollData() {
  // Gets the scrollTop and direction and updates the global variables accordingly
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  if (window.st > lastScrollTop) {
    window.scrollDirection = "down";
  } else {
    window.scrollDirection = "up";
  }
  if (window.st <= window.hh) {
    $header.addClass("near-top");
  } else {
    $header.removeClass("near-top");
  }
  lastScrollTop = window.st <= 0 ? 0 : window.st; // For Mobile or negative scrolling
}

function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  window.ww = document.documentElement.clientWidth; //$(window).width(); - CHANGED to avoid reflows.
  window.wh = document.documentElement.clientHeight; //$(window).height(); - CHANGED to avoid reflows.
  window.hh = $("#header").outerHeight(); // $("header").outerHeight();

  //var root = document.querySelector(':root');
  //root.style.setProperty('--header-height', `${window.hh}px`);

  // Check if we are in Mobile (ie Responsive mode)
  if ($('.hamburger').is(":visible")) {
    is_responsive = true;
  } else {
    is_responsive = false;
  }
  if (!isSitefinityEditor()) {
    refreshScrollData(); // refresh scroll data just in case...
    refreshForcedWidthContainers();
    if (typeof window.updateJumpMenuOffsetValues === "function") {
      window.updateJumpMenuOffsetValues();
    }
    if (typeof updateSidebarOffsetValues === "function") {
      updateSidebarOffsetValues();
    }
  }
}

/****************************************************************************************************/
/* Containers */
/****************************************************************************************************/
function refreshScrollbarWidthValue() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  try {
    scrollbarWidth = getScrollbarWidth();
  } catch {
    console.log("unable to calculate scrollbar width automatically.");
  }
}
function getTopLevelScrollBarWidth() {
  var scrollbarWidth = 0;
  if (document.body.scrollHeight > document.body.clientHeight || document.documentElement.scrollHeight > document.documentElement.clientHeight) {
    scrollbarWidth = getScrollbarWidth();
  }
  return scrollbarWidth;
}

/* Updates the max-width of edge-to-edge containers to account for scrollbars */
function refreshForcedWidthContainers() {
  //var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  //try {
  //    scrollbarWidth = getScrollbarWidth();
  //    console.log({ scrollbarWidth });
  //}
  //catch {
  //    console.log("unable to calculate scrollbar width automatically.");
  //}
  var scrollbarWidth = getTopLevelScrollBarWidth();
  //var width = "calc(100vw - " + scrollbarWidth + "px)";
  //var $forcedWidthContainers = $(".container.edge, .container.force");
  //$forcedWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  //$edgeWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  // ToDo: try doing this with a custom property instead:
  let root = document.documentElement;
  root.style.setProperty('--scrollbar-width', scrollbarWidth + "px");
}
function getScrollbarWidth() {
  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

/****************************************************************************************************/
/* Document Ready */
/****************************************************************************************************/
window.addEventListener('DOMContentLoaded', function () {
  $header = $("#header");
  refreshDimensions();
  $(window).trigger('resize');
  setTimeout(refreshDimensions, 2000); // re-run after a few seconds to capture any late layout shifts (from fonts loading or other)
});

/****************************************************************************************************/
/* Jump Menu */
/****************************************************************************************************/
window.jumpMenuColourChangeOffsets = []; // used elsewhere, don't delete
//window.addEventListener('DOMContentLoaded', function () {
//    window.$jumpMenu = $(".jumpMenu");
//    window.$jumpMenuAnchors = $jumpMenu.find("a");
//    if (typeof updateJumpMenuOffsetValues === "function") {
//        updateJumpMenuOffsetValues();
//    }
//});

if (typeof window.checkJumpMenuItems === "function") {
  document.addEventListener('scroll', window.checkJumpMenuItems);
}
window.updateJumpMenuOffsetValues = function () {
  // runs on resize/recalc
  window.jumpMenuColourChangeOffsets = [];
  window.$jumpMenuColourChangeWrappers = $(".jumpMenuColourChange");
  if (window.$jumpMenuColourChangeWrappers.length) {
    window.$jumpMenuColourChangeWrappers.each(function () {
      let $this = $(this);
      let offset = $this.offset();
      let color = "white"; // default
      if ($this.hasClass("primary")) {
        color = "primary";
      }
      window.jumpMenuColourChangeOffsets.push({
        top: offset.top,
        bottom: offset.top + $this.outerHeight(),
        color: color
      });

      //$this.attr("data-top", offset.top);
      //$this.attr("data-bottom", offset.top + $this.outerHeight());
    });
  }
};

window.checkJumpMenuItems = function () {
  // runs on scroll
  if (window.$jumpMenuAnchors && window.$jumpMenuAnchors.length) {
    const WIGGLE = 2; // pixels. Adjust this number arbitrarily to tweak when the color change happens
    for (const element of window.$jumpMenuAnchors) {
      let $element = $(element); // the sticky element (.jumpMenu li a)
      let height = $element[0].clientHeight; // height of the sticky element
      let offset = $element.offset(); // the y-offset of the sticky element
      let isOverlappingWrapper = false;
      for (const wrapperOffset of window.jumpMenuColourChangeOffsets) {
        if (offset.top >= wrapperOffset.top - height + WIGGLE && offset.top < wrapperOffset.bottom) {
          isOverlappingWrapper = true;
        }
        if (isOverlappingWrapper) {
          $element.addClass(wrapperOffset.color);
        } else {
          $element.removeClass(wrapperOffset.color);
        }
      }
    }
  }
};

// Jump Menu
// Requires an empty ul with class of .jumpMenu and adds all elements with class of jumpTitle
window.addEventListener('DOMContentLoaded', function () {
  window.$jumpMenu = $(".jumpMenu");
  if (window.$jumpMenu.length) {
    $(".jumpTitle").each(function () {
      addScrollMenu($(this).html(), $(this));
    });
    window.$jumpMenuAnchors = window.$jumpMenu.find("a");
    if (typeof window.updateJumpMenuOffsetValues === "function") {
      window.updateJumpMenuOffsetValues();
      //setTimeout(window.updateJumpMenuOffsetValues, 2000);
    }
  }
});

if (typeof window.checkJumpMenuItems === "function") {
  document.addEventListener('scroll', window.checkJumpMenuItems);
}
function addScrollMenu(name, sectionName) {
  var anchor = name.replace(/ /g, '').replace('&', 'and');
  var replaced = name.replace('<br>', ' ');
  $(".jumpMenu").append(`<li><a href='#${anchor}'>${replaced}</a></li>`);
  $(sectionName).closest("section").attr("id", anchor);
}

/***** */
/* Toggle Hidden and Refresh JumpMenu Offsets
/****** */
window.addEventListener('DOMContentLoaded', function () {
  addToggleHiddenListener();
});
function addToggleHiddenListener() {
  var parentElement = document.querySelector('.mainBio');
  if (parentElement) {
    parentElement.addEventListener('click', function (event) {
      if (event.target && event.target.matches('.toggleHidden')) {
        var hiddenDiv = event.target.getAttribute('data-target');
        var fadeMeChild = parentElement.querySelector('.highlightFirstElement');
        if (fadeMeChild) {
          toggleFadeMe(fadeMeChild);
        }
        toggleHidden(document.querySelector(hiddenDiv));
        toggleButtonText(event.target);
        refreshDimensions();
      }
    });
  }
}
function toggleFadeMe(fadeMeDiv) {
  fadeMeDiv.classList.toggle('fademe');
}
function toggleHidden(hiddenDiv) {
  hiddenDiv.classList.toggle('hidden');
}
function toggleButtonText(button) {
  var buttonText = button.innerText.toLowerCase(); // Convert button's text content to lowercase
  if (buttonText === 'read more') {
    // Compare with lowercase string
    button.innerText = 'Read less';
  } else {
    button.innerText = 'Read more';
  }
}
/****************************************************************************************************/
/* Scroll Events */
/****************************************************************************************************/

var mainScrollEvent = function () {
  $header = $("#header");
  refreshScrollData();

  // Scroll-to-top link
  if (lastScrollTop > 450) {
    $('.scrollToTop').fadeIn();
  } else {
    $('.scrollToTop').fadeOut();
  }
  $header.removeClass("down up").addClass(window.scrollDirection);
  if (lastScrollTop === 0) {
    $header.addClass("top");
  } else {
    $header.removeClass("top");
  }
};

// optimized event handler: https://web.dev/uses-passive-event-listeners/
document.addEventListener('scroll', mainScrollEvent, {
  passive: true
});

/****************************************************************************************************/
/* Smooth Scrolling */
/****************************************************************************************************/

$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - $("#header").outerHeight()
      }, 1000, function () {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) {
          // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        }
        ;
      });
    }
  }
});

/****************************************************************************************************/
/* Window Resizing */
/****************************************************************************************************/

$(window).on('resize', function () {
  refreshDimensions();
});

/****************************************************************************************************/
/* #region Lottie Animations */
/****************************************************************************************************/

window.setupLottieAnimations = function () {
  $(".bodymovin").each(function () {
    window.setupLottieAnimation($(this));
  });
};
window.setupLottieAnimation = function ($element) {
  if ($element.hasClass("loaded")) {
    return;
  }
  var animationName = $element.data("animation-name") ?? "banner";
  var animation = bodymovin.loadAnimation({
    container: $element[0],
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: `/Banners/lottie/${animationName}.json`
  });
  //lottie.pause();
  animation.stop();
  $element.data("lottie", animation);
  $element.addClass("loaded");
};
$(document).ready(function () {
  window.setupLottieAnimations();
});

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region Animation Scroll Observer */
/****************************************************************************************************/

window.setupAnimationScrollObservers = function () {
  // setup intersection observer
  let options = {
    //root: document.querySelector("body"),
    rootMargin: "0px",
    threshold: 0
  };
  let callback = (entries, observer) => {
    //console.log({entries});
    entries.forEach(entry => {
      // Each entry describes an intersection change for one observed
      // target element:
      //   entry.boundingClientRect
      //   entry.intersectionRatio
      //   entry.intersectionRect
      //   entry.isIntersecting
      //   entry.rootBounds
      //   entry.target
      //   entry.time
      if (entry.isIntersecting) {
        //console.log("visible");
        $(entry.target).addClass("visible");

        //let $video = $(entry.target).find("video");
        //$video[0].currentTime = .5;
        //$video.trigger('play');

        let $lottieElement = $(entry.target).find(".bodymovin");
        let lottie = $lottieElement.data("lottie");
        //debugger;
        if (lottie) {
          //lottie.seek(500);
          //lottie.seek("50%");
          //console.log(lottie.totalFrames);
          //console.log(lottie.seek);
          lottie.play();
        }
      }
    });
  };
  let observer = new IntersectionObserver(callback, options);
  var $scrollVideos = $(".scrollVideoWrapper");
  $scrollVideos.each(function () {
    observer.observe($(this)[0]);
  });
};
$(document).ready(function () {
  window.setupAnimationScrollObservers();
});

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* Sliders / Carousels */
/****************************************************************************************************/

/* multi-item slider: on mounted (prevent issues with looping, perPage, arrows, etc ) */
function onMountedMultiItemSlider(splide) {
  console.log("multi-item slider mounted!", splide);
  if (!splide.options.fixedWidth && !splide.options.autoWidth) {
    if (splide.options.perPage && splide.Components.Slides.getLength(true) <= splide.options.perPage) {
      $(splide.root).addClass("noSliderNeeded"); // add a class so we can adjust styling if needed
      splide.options.drag = false;
      splide.options.noDrag = "*"; // I don't think we should need this, however for now it prevents unwanted dragging even when drag is disabled.
      splide.options.arrows = false;
      splide.options.pagination = false;
      splide.options.type = 'slide';
      splide.options.classes.arrows += " hiddenArrows";
      $(splide.Components.Elements.arrows).attr("class", splide.options.classes.arrows); // force our custom HTML arrows to use the reactive Splide classes
      //splide.Components.Arrows.destroy(); // doesn't work ...
      splide.refresh();
    }
  }
}

/* auto-height slider: shared event callbacks */
var autoHeightEvents = {
  mounted: onMountedAutoHeightSlider,
  refresh: onMountedAutoHeightSlider,
  move: onMoveAutoHeightSlider
};

/* updates the slider height during the slider move event */
function onMoveAutoHeightSlider(newIndex, prevIndex, destIndex, splide) {
  var height = $(splide.Components.Elements.slides[newIndex]).outerHeight();
  updateSliderHeight(splide, height);
}
function onMountedAutoHeightSlider(splide) {
  //if (splide.Components.Elements.slides.length <= 1) {
  //    splide.destroy();
  //    $(splide.root).find(".splide__arrows").hide();
  //}
  $(splide.root).find(".splide__list").css({
    alignItems: "flex-start"
  });
  var height = $(splide.Components.Elements.slides[splide.index]).outerHeight();
  updateSliderHeight(splide, height);
  setTimeout(function () {
    updateSliderHeight(splide, height);
  }, 2000);
}
function updateSliderHeight(splide, height) {
  if (splide && height) {
    $(splide.Components.Elements.track).animate({
      height: height + "px"
    }, {
      duration: splide.options.speed
      //complete: function () { }
    });
  }
}

;

/**
 * How to use our splide configs (SIMPLE):
 * 
 * 1. Get your slider HTML onto the page (i.e. from a View or static block). Basic splide classes and markup are required here.
 * 2. Make sure the ".splide" element has a custom data attribute 'data-splide-preset' (e.g. 'data-splide-preset="single"')
 * 3. That's it. The code below will locate your ".splide[data-splide-preset]" element and render it using the specified configuration.
 * 
 */

/*
 Global splide config. Used a base for ALL splide sliders. 
 */
window.globalSplideConfig = {
  type: 'loop'
  //start: 0,
  //perPage: 1,
  //perMove: 1,
  //pagination: true,
  //arrows: false,
  //autoHeight: true,
  //rewind: false,
  //speed: '500',
  //autoplay: true,
  //easing: 'cubic-bezier(.12,.8,.47,.98)',
  //accessibility: true,
  //classes: {
  //    //arrows: 'splide__arrows your-class-arrows',
  //    //arrow: 'splide__arrow your-class-arrow',
  //    prev: 'splide__arrow--prev fas fa-chevron-left',
  //    next: 'splide__arrow--next fas fa-chevron-right',
  //},
  //throttle: 10, // throttle the resize function (default 100 ms)
};

/*
 Slider presets. These get merged with the globalSplideConfig options to configure ALL splide sliders throughout the site.
 */

window.heroFirstSlideDelay = 500;
window.heroSliderTimeouts = [];
window.hasRunFirstSlide = false;

/*function RedgraveMattersTransition(Splide, Components) {
    const { bind } = EventInterface(Splide);
    const { Move } = Components;
    const { list } = Components.Elements;

    let endCallback;

    function mount() {
        bind(list, 'transitionend', e => {
            if (e.target === list && endCallback) {
                // Removes the transition property
                cancel();

                // Calls the `done` callback
                endCallback();
            }
        });
    }

    function start(index, done) {
        // Converts the index to the position
        const destination = Move.toPosition(index, true);

        // Applies the CSS transition
        list.style.transition = 'transform 800ms cubic-bezier(.44,.65,.07,1.01)';

        // Moves the carousel to the destination.
        Move.translate(destination);

        // Keeps the callback to invoke later.
        endCallback = done;
    }

    function cancel() {
        list.style.transition = '';
    }

    return {
        mount,
        start,
        cancel,
    };
}*/

var isFirstSlideAnimation = true;
var isHomeSliderPlaying = false;
function updateAnimatedTitle($slide) {
  //debugger;
  var $firstWord = $slide.find("h1 span span:nth-child(1)");
  let newWord = $firstWord.text();
  let newWidth = $firstWord.outerWidth();
  let $animatedTitle = $("#animatedTitle");
  let $swap = $animatedTitle.find(".swap");
  $swap.removeClass("focus");
  if (isFirstSlideAnimation) {
    $swap.css({
      width: 0,
      opacity: 0,
      marginRight: "-0.3em" // account for gap
    });

    $swap.text(newWord);
    $animatedTitle.fadeTo(1000, 1, function () {
      // when finished fading in ...
      $swap.animate({
        width: newWidth,
        marginRight: "-0em" // account for gap
      }, {
        duration: 1000,
        complete: function () {
          $slide.find(".cardContent").fadeTo(1000, 1);
          //$animatedTitle.fadeTo(1000, 1);
          $swap.addClass("focus").fadeTo(1000, 1);
        }
      });
    });
    isFirstSlideAnimation = false;
    //setTimeout(function () {
    //    $slide.find(".cardContent").fadeTo(1000, 1);
    //    $animatedTitle.fadeTo(1000, 1);
    //    $swap.addClass("focus");
    //}, 1000);
  } else {
    $(".homeSlideshow .cardContent").css({
      opacity: 0
    });

    //$swap.fadeTo(1000, 0, function () {
    //    $swap.removeClass("focus");
    //    $swap.animate({
    //        width: newWidth
    //    }, {
    //        duration: 1000,
    //        complete: function () {
    //            $swap.text(newWord);
    //            $swap.fadeTo(1000, 1);
    //            $swap.addClass("focus");

    //            $slide.find(".cardContent").fadeTo(1000, 1);
    //        }
    //    });
    //});

    $swap.removeClass("focus");
    $swap.animate({
      width: newWidth
    }, {
      duration: 1000,
      complete: function () {
        $swap.text(newWord);
        $swap.fadeTo(1000, 1);
        $swap.addClass("focus");
        $swap.css({
          width: "auto"
        });
        $slide.find(".cardContent").fadeTo(1000, 1);
      }
    });
  }
}
window.SplideConfigurations = [/* Default configuration */
{
  name: "default",
  //start: 0,
  type: 'loop',
  perPage: 3,
  perMove: 1,
  gap: "2rem",
  pagination: false,
  breakpoints: {
    1024: {
      perPage: 2
    },
    640: {
      perPage: 1
    }
  },
  variants: [{
    // config that inherits/overrides a parent config
    name: "default-no-dots",
    pagination: false
  }],
  on: {
    mounted: onMountedMultiItemSlider,
    beforeMounted: function (splide) {
      console.log("triggered beforeMounted event. Splide: ", splide);
    }
  }
}, /* Single Slide Resources */
{
  name: "single",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  pagination: false,
  variants: [{
    name: "single-auto-height",
    autoHeight: true,
    fixedHeight: false
    //on: Object.assign(autoHeightEvents, { // combine shared events with custom ones
    //    mounted: onMountedMultiItemSlider
    //}),
  }],

  on: {
    mounted: onMountedMultiItemSlider
  }
}, /* Single Slide Resources */
{
  name: "testimonials",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  pagination: true,
  arrows: false
}, /* one-three-grid Resources */
{
  name: "one-three-grid",
  type: 'loop',
  start: 0,
  perPage: 3,
  perMove: 3,
  gap: "2rem",
  pagination: false,
  breakpoints: {
    1024: {
      perPage: 2,
      perMove: 2
    },
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* Double (2-item) sliders  */
{
  name: "double",
  type: 'loop',
  start: 0,
  perPage: 2,
  perMove: 2,
  gap: "2rem",
  pagination: false,
  breakpoints: {
    1024: {
      perPage: 1,
      perMove: 1
    }
  },
  variants: [{
    name: "double-auto-height",
    autoHeight: true,
    fixedHeight: false,
    on: Object.assign(autoHeightEvents, {// combine shared events with custom ones
      // move: function(){}
    })
  }]
}, /* Homeslideshow / Hero */
{
  name: "hero",
  type: 'fade',
  start: 0,
  perMove: 1,
  arrows: false,
  pagination: true,
  autoplay: false,
  interval: 10000,
  rewind: true,
  pauseOnHover: false,
  drag: false,
  paginationKeyboard: false,
  on: {
    mounted: function (splide) {
      // start the video
      //var $video = $(".homeSlideshow video").eq(0);
      //if ($video.length) {
      //    $video.get(0).currentTime = 0;
      //    $video.trigger('play');
      //}

      var $lotties = $(".homeSlideshow .bodymovin");
      $lotties.each(function () {
        var lottie = $(this).data("lottie");
        if (lottie) {
          lottie.play();
        }
      });
      var duration = splide.options.interval; // get the interval from the configuration
      var transitionOutTimeout = duration * 0.9; // when to start fading-out first word

      var Autoplay = splide.Components.Autoplay;
      var Controller = splide.Components.Controller;
      var firstSlide = splide.Components.Slides.getAt(0);
      var $slide = $(firstSlide.slide);
      setTimeout(function () {
        // this timeout delays the start of the slider. It mainly exists to wait for fonts to load
        Controller.go(0);
        Autoplay.play();
        isHomeSliderPlaying = true;
        setTimeout(function () {
          let $animatedTitle = $("#animatedTitle");
          $animatedTitle.find(".swap").fadeTo(1000, 0);
          $slide.find(".cardContent").fadeTo(1000, 0);
        }, transitionOutTimeout);
        updateAnimatedTitle($slide);
      }, 1000);
    },
    active: function (slide, splide) {
      var $slide = $(slide.slide);
      var duration = splide.options.interval; // get the interval from the configuration
      var transitionOutTimeout = duration * 0.9; // when to start fading-out first word

      if (isHomeSliderPlaying) {
        setTimeout(function () {
          let $animatedTitle = $("#animatedTitle");
          $animatedTitle.find(".swap").fadeTo(1000, 0);
          $slide.find(".cardContent").fadeTo(1000, 0);
        }, transitionOutTimeout);
        updateAnimatedTitle($slide);
      }
    },
    inactive: function (slide, splide) {
      //$slide.removeClass("transition-out");
      //$(slide.slide).find("h1 span span").css({
      //    width: "initial"
      //});
    }
  }
}, /* Fade */
{
  name: "fade",
  type: 'fade',
  start: 0,
  perPage: 1,
  perMove: 1,
  autoplay: true,
  pagination: false,
  updateOnMove: true
}, /* Fade */
{
  name: "home",
  type: 'fade',
  start: 0,
  perPage: 1,
  perMove: 1,
  autoplay: true,
  pagination: true,
  updateOnMove: true,
  interval: 7000,
  pauseOnHover: false,
  pauseOnFocus: false,
  /* Scroll Options */
  //wheel: true,
  //wheelSleep:500,
  //waitForTransition: false,
  //releaseWheel: true,

  on: {
    mounted: function (splide) {
      // set the first slide colour (red)
      var initialSlideColour = "red";
      $("body").addClass(initialSlideColour);
      $(splide.root).find(".splide__slide").eq(0).addClass(initialSlideColour);
    },
    move: function (newIndex, prevIndex, destIndex, splide) {
      var $body = $("body");

      // get the color of the prevIndex slide
      var prevSlide = splide.Components.Slides.getAt(prevIndex);
      var destSlide = splide.Components.Slides.getAt(destIndex);
      var $prevSlide = $(prevSlide.slide);
      var $destSlide = $(destSlide.slide);
      //debugger;

      var prevColor = "";
      var nextColor = "";
      if ($prevSlide.hasClass("red")) {
        prevColor = "red";
        nextColor = "white";
        //$destSlide.removeClass("red").addClass("white");
      } else {
        prevColor = "white";
        nextColor = "red";
      }

      //console.log("the last slide was " + prevColor);
      //console.log("next slide should be " + nextColor);

      // add the coilor class to the next slide
      $destSlide.removeClass("red white").addClass(nextColor);
      $body.removeClass("red white").addClass(nextColor);
    }
  }
}, /* Fixed Width */
{
  name: "fixedWidth",
  fixedWidth: '32rem',
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  gap: "2rem",
  pagination: false,
  breakpoints: {
    600: {
      fixedWidth: '18rem'
    }
  }
}];

//document.fonts.onloadingdone = function (fontFaceSetEvent) {
//    alert('onloadingdone we have ' + fontFaceSetEvent.fontfaces.length + ' font faces loaded');
//};

/* Get a splide configration matching a given name */
function getSplideConfiguraion() {
  let splideConfigurationName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  let mergedConfiguration = {};
  for (var configuration of window.SplideConfigurations) {
    if (configuration.name === splideConfigurationName) {
      mergedConfiguration = mergeConfigurations({}, configuration);
      break;
    } else if (configuration.hasOwnProperty("variants") && configuration.variants.length) {
      for (var variant of configuration.variants) {
        if (variant.name === splideConfigurationName) {
          mergedConfiguration = mergeConfigurations(configuration, variant);
          // remove unneeded properties
          delete mergedConfiguration.variants;
          //delete mergedConfiguration.name;
          break;
        }
      }
    }
  }
  mergedConfiguration = mergeConfigurations(window.globalSplideConfig, mergedConfiguration);
  return mergedConfiguration;
}

/* merge two splide configurations intelligently (rather than blindly overwriting each other) */
function mergeConfigurations(config1, config2) {
  let mergedConfiguration = Object.assign({}, config1, config2);

  // merge the "on" callbacks/arrays. this allows configurations to inherit event callbacks (such as 'mounted') from the default configuration (and variants to inherit from their parents)
  if (config1.hasOwnProperty("on") && config2.hasOwnProperty("on")) {
    for (const [eventName, config1Callbacks] of Object.entries(config1.on)) {
      // loop through the config1 on callbacks
      if (typeof config2.on[eventName] !== "undefined") {
        let config2Callbacks = config2.on[eventName] || [];
        mergedConfiguration.on[eventName] = mergeCallbacks(config1Callbacks, config2Callbacks);
      }
    }
  }
  return mergedConfiguration;
}

/* takes two arguments (function or array of functions) and returns a merged, unique array of those functions */
/* primarily used for combining the "on" agruments/callbacks of several splide configurations */
function mergeCallbacks(cbArray1, cbArray2) {
  cbArray1 = Array.isArray(cbArray1) ? cbArray1 : [cbArray1];
  cbArray2 = Array.isArray(cbArray2) ? cbArray2 : [cbArray2];
  return [...new Set([...cbArray1, ...cbArray2])]; // creates a unique merged array (removes duplicate function references)
}

/* Initiate a splide slider using one of our configurations and all of our custom logic. */
function initSplideSlider($selector, configurationName) {
  let $slider = $($selector);
  let configuration = getSplideConfiguraion(configurationName);
  let splide = new Splide($slider[0], configuration);

  /* register custom event callbacks defined in the configuration object */
  if (typeof configuration.on !== "undefined") {
    for (const eventName in configuration.on) {
      /* BEFORE MOUNT EVENT (custom CF event) - allows us to do things prior to initializing a slider */
      if (eventName === "beforeMounted") {
        let beforeMountedCallbacks = Array.isArray(configuration.on[eventName]) ? configuration.on[eventName] : [configuration.on[eventName]];
        /* loop through the beforeMounted callbacks and run them */
        beforeMountedCallbacks.forEach(function (beforeMountedCallback, index) {
          if (typeof beforeMountedCallback === "function") {
            beforeMountedCallback(splide);
          }
        });
        delete configuration.on[eventName]; // remove these non-splide events as they are not needed beyond this point.
        continue;
      }

      /* event binding - allows for mutiple functions to be bound to a single callback. */
      let callbacks = Array.isArray(configuration.on[eventName]) ? configuration.on[eventName] : [configuration.on[eventName]];
      for (const callback of callbacks) {
        if (typeof callback === "function") {
          splide.on(eventName, function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            // this is a closure. we capture the default args, then add our own 
            callback(...args, splide);
          });
        }
      }
    }
  }

  // add it to our list of registered sliders (for potential later use)
  window.splideSliders = window.splideSliders || [];
  window.splideSliders.push({
    el: $slider,
    splide,
    configuration
  });

  // mount splide
  //if (configuration.name == "hero") {
  //    splide.mount({}, RedgraveMattersTransition);
  //} else {
  //    splide.mount();
  //}

  splide.mount();
}

/* Loop through our widget / view sliders and initiate them using their preset configs */
window.splideSliders = window.splideSliders || [];
$(".splide[data-splide-preset]").not(".is-active").each(function (i, el) {
  let $slider = $(this);
  let configurationName = $slider.attr("data-splide-preset");
  initSplideSlider($slider, configurationName);
});

/****************************************************************************************************/
/* Search Box Non-Modal Toggle */
/****************************************************************************************************/

$(function () {
  $("a.searchExpand").on("click", function () {
    $(".searchHiddenWrapper").slideToggle();
  });
  $("button.searchCollapse").on("click", function () {
    $(".searchHiddenWrapper").slideToggle();
  });
});

/****************************************************************************************************/
/* Forms / Autofill */
/****************************************************************************************************/
// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

/****************************************************************************************************/
/* Misc */
/****************************************************************************************************/

// check if we're running inside the SF Page editor
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $this = $(this);
  if (!isSitefinityEditor()) {
    // If there's not data-url, then find the first child el with an href and use that
    var itemUrl = "";
    var target = "_self"; // default

    // allow links within to work
    if ($(event.target).is('a[href]')) {
      return;
    }

    // First check for data atts. If none, use the first child link
    else if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
      itemUrl = $this.data("url");
      if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
        target = $this.data("target");
      }
    } else {
      var $firstLinkFound = $this.find("a[href]").first();
      itemUrl = $firstLinkFound.attr("href");
      target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
    }
    window.open(itemUrl, target);
  }
});

// Play Audio 
window.addEventListener('DOMContentLoaded', function () {
  $(document).on("click", ".audioFile a", function () {
    playAudio($(this).attr("data-audioid"));
    return false;
  }).on("keypress", ".audioFile a", function (e) {
    if (e.which === 13) {
      // enter key code
      playAudio($(this).attr("data-audioid"));
      return false;
    }
  });

  // Play Audio
  function playAudio($audioid) {
    var audioFile = $('#' + $audioid).addClass("playing").get(0).play();
  }
});

///Copyright Script
var publishedDate = 2022;
var year = $('.copyrightYear');
if (year.html() == publishedDate) {
  year.html(publishedDate);
} else {
  year.html(publishedDate + '-' + new Date().getFullYear());
}
if (!isSitefinityEditor()) {
  document.addEventListener('DOMContentLoaded', function () {
    //callback function: simply adds a class when the element is in the viewport
    function observerCallback(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('inViewport');
        }
      });
    }

    //only activate when an element is 20% visible
    let observerOptions = {
      //threshold: .15,
      threshold: 0
    };

    //create an intersection observer to watch
    var observer = new IntersectionObserver(observerCallback, observerOptions);

    //let wrapperTarget = 'blockquote,.checkIfInViewport, .cmsContent:not(header *), .cardView, h1:not(.homeSlideshow h1)'; //stop adding inViewPort to templates during editing
    let wrapperTarget = 'blockquote,.checkIfInViewport, .cmsContent:not(header *), .cardView'; //stop adding inViewPort to templates during editing
    if (!!window.IntersectionObserver) {
      //check if browser supports it, 
      document.querySelectorAll(wrapperTarget).forEach(el => {
        if (el) {
          el.classList.add("observed");
          observer.observe(el);
        }
      });
    }
  });
}

////Kendo treeview to create accordions in layouts
//window.addEventListener('DOMContentLoaded', function () {

//    var $treeViewAccordion = $(".accordionGroup");
//    var treeView = $treeViewAccordion.kendoTreeView({
//        expandMode: "multiple",
//    });

//    //var $firstAccordian = $treeViewAccordion.find(".k-first");
//    //$firstAccordian.attr('data-expanded', true).attr('aria-expanded', true);
//    //// Change Icon
//    //$firstAccordian.find(".k-icon").removeClass("k-i-expand").addClass("k-i-collapse");
//    //// Expand k-group by changing the style
//    //$firstAccordian.find(".k-group").attr('style', 'overflow: visible; display: block; height: auto;');
//});

/* Toggle Filters Groups on Checkbox FilteredContent */
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('filterToggle')) {
    // Prevent Default Action
    event.preventDefault();
    const toggleFilterClicked = event.target;
    const toggleFilterContentToControl = toggleFilterClicked.nextElementSibling;
    if (toggleFilterClicked.classList.contains('active')) {
      /* already has 'active' the class remove it */
      toggleFilterClicked.classList.remove('active');
      toggleFilterContentToControl.classList.remove('active');
    } else {
      /* add the 'active' class */
      toggleFilterClicked.classList.add('active');
      toggleFilterContentToControl.classList.add('active');
    }
  }
}, false);
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, {
      passive: true
    });
  }
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, {
      passive: true
    });
  }
};

/****************************************************************************************************/
/* Accordions */
/****************************************************************************************************/

var groupClass = "group";
var expandedClass = "active";
window.addEventListener('DOMContentLoaded', function () {
  var $accordions = $(".accordion"); //.not(".disabled");
  if ($accordions.length && !isSitefinityEditor()) {
    // Add accessibility attributes
    updateAccordionAccessibilityAtts();

    // Add expand/collapse all button to first accordion
    //$accordions = $(".accordion");
    //if ($accordions.length > 1) {
    //    $("<div class='btnExpandAll expand'>Expand All</div>").prependTo($accordions.first());
    //    $accordions.first().addClass("hasExpandAll");
    //}
    // ToDo: Find a better way of adding the expand/collapse all button without making the <dl> markup invalid

    // Expand first 
    if ($(".accordion." + expandedClass).length) {
      expandAccordion($(".accordion." + expandedClass).first());
    }

    // Open all accordions with the "active" class
    $(".accordion.active").each(function () {
      var $accordion = $(this);
      expandAccordion($accordion);
    });

    // Click & Keypress handlers
    $(".accordion .accordionTop").on("click", function (ev) {
      toggleAccordion($(this).parent(".accordion"));
    }).on("keypress", function (ev) {
      if (ev.which === 13) {
        // enter key code
        toggleAccordion($(this).parent(".accordion"));
      }
    });

    // Expand / Collapse All accordions
    $(".btnExpandAll").on("click", function () {
      //debugger;
      var $button = $(this);
      if ($button.hasClass("expand")) {
        $accordions.each(function () {
          expandAccordion($(this)); // expand each accordion
        });

        updateExpandAllButton();
      } else {
        $accordions.each(function () {
          collapseAccordion($(this)); // close each accordion
        });

        updateExpandAllButton();
      }
    });
  }
});
function updateAccordionAccessibilityAtts() {
  // Make sure they're tab navigable/focusable
  $(".accordion").each(function (i, el) {
    var $accordion = $(el);
    var $accordionTop = $accordion.find(".accordionTop");
    var $accordionBottom = $accordion.find(".accordionBottom");
    if ($accordionTop.length && $accordionBottom.length) {
      // make sure accordionBottoms have unique Ids
      var accordionTopId = $accordionTop.uniqueId().attr("id");
      var accordionBottomId = $accordionBottom.uniqueId().attr("id");

      // make accodions focusable
      $accordionTop.attr("tabindex", "0");
      $accordionTop.attr("role", "button");
      var accordionTitle = $accordionTop.text().trim();
      if (!$accordionTop[0].hasAttribute("aria-label") && $accordionTop.attr("aria-label") !== "") {
        $accordionTop.attr("aria-label", accordionTitle);
        $accordionBottom.attr("aria-labeledby", accordionTopId);
        $accordionTop.attr("aria-controls", accordionBottomId);
        if ($accordionTop.is(".active")) {
          $accordionTop.attr("aria-expanded", "true");
          $accordionBottom.attr("aria-hidden", "false");
        } else {
          $accordionTop.attr("aria-expanded", "false");
          $accordionBottom.attr("aria-hidden", "true");
        }
      }
    }
  });
}

// Update the expand button to reflect current state of accordions
function updateExpandAllButton() {
  var $button = $(".btnExpandAll");
  var $accordions = $(".accordion");
  var $activeAccordions = $accordions.filter(".active");
  if ($button.length && $accordions.length > $activeAccordions.length) {
    // if some are open (but not all) then set to expand
    $button.addClass("expand");
    $button.text("Expand All");
  } else {
    $button.removeClass("expand");
    $button.text("Collapse All");
  }
}

// Toggle the target accordion
function toggleAccordion($accordion) {
  if ($accordion.hasClass(expandedClass)) {
    collapseAccordion($accordion);
  } else {
    closeGroupMembers($accordion); // close group members first
    expandAccordion($accordion);
  }
  updateExpandAllButton();
  refreshDimensions();
}

// Expand single accordion (and upate group)
function expandAccordion($accordion) {
  $accordion.addClass(expandedClass);
  $accordion.find(".accordionTop").addClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "true");
  $accordion.find(".accordionBottom").addClass(expandedClass).slideDown();
  $accordion.find(".accordionBottom").attr("aria-hidden", "false");
  $accordion.find(".accordionBottom").prop("hidden", false);
  updateExpandAllButton();
  refreshDimensions();
}

// Close single accordion (and upate group)
function collapseAccordion($accordion) {
  $accordion.removeClass(expandedClass);
  $accordion.find(".accordionTop").removeClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "false");
  $accordion.find(".accordionBottom").removeClass(expandedClass).slideUp();
  $accordion.find(".accordionBottom").attr("aria-hidden", "true");
  $accordion.find(".accordionBottom").prop("hidden", true);
  updateExpandAllButton();
  refreshDimensions();
}

// Check if accordion in group. If so, update group members
function closeGroupMembers($accordion) {
  var classes = $accordion[0].className.trim().split(/ |\t|\|/); // get array of classes (regex to account for space, tab, and pipe separators)
  var groups = $.grep(classes, function (classes, i) {
    // get only the classes containing groupClass
    return classes.indexOf(groupClass) === 0;
  });
  $.each(groups, function (i, group) {
    $(".accordion." + group).each(function () {
      collapseAccordion($(this)); // close each grouped accordion
    });
  });
}